import React, { useState, useEffect } from 'react';

export default function HighlightDiv({ rect, zoom }) {
  const [layerSize, setLayerSize] = useState({ width: 0, height: 0 });
  const divRef = React.useRef(null);

  useEffect(() => {
    const updateLayerSize = () => {
      const textLayer = divRef.current?.parentElement;
      if (!textLayer) return;
      const r = textLayer.getBoundingClientRect();
      setLayerSize({ width: r.width, height: r.height });
    };
    
    updateLayerSize();
    window.addEventListener("resize", updateLayerSize);
    
    // Also update on zoom changes
    const timeoutId = setTimeout(updateLayerSize, 100);
    
    return () => {
      window.removeEventListener("resize", updateLayerSize);
      clearTimeout(timeoutId);
    };
  }, [zoom]); // Re-run when zoom changes

  // Convert normalized to pixel coordinates
  const pixelTop = rect.normalizedTop * layerSize.height;
  const pixelLeft = rect.normalizedLeft * layerSize.width;
  const pixelWidth = rect.normalizedWidth * layerSize.width;
  const pixelHeight = rect.normalizedHeight * layerSize.height;

  // Debug logging
  useEffect(() => {
    console.log('HighlightDiv rendering:', {
      rect,
      layerSize,
      pixelCoords: { pixelTop, pixelLeft, pixelWidth, pixelHeight },
      zoom
    });
  }, [rect, layerSize, zoom]);

  return (
    <div
      ref={divRef}
      style={{
        position: "absolute",
        top: `${pixelTop}px`,
        left: `${pixelLeft}px`,
        width: `${pixelWidth}px`,
        height: `${pixelHeight}px`,
        background: "rgba(255, 230, 0, 0.45)",
        borderRadius: "2px",
        transform: "translateZ(0)",
        pointerEvents: "none",
      }}
    />
  );
}